/**
 * アコーディオン
 * 
 * コンテナ
 * [data-accordion]
 * 
 * コンテナ展開時
 * [data-accordion][data-accordion-expanded]
 * 
 * トグル
 * [data-accordion-toggle]
 * 
 * コンテンツ
 * [data-accordion-content]
 */

function toggleAccordion(accordion) {
    if (accordion.hasAttribute('data-accordion-expanded')) {
        closeAccordion(accordion);
        return false;
    } else {
        openAccordion(accordion);
        return true;
    }
}

function closeAccordion(accordion) {
    const content = accordion.querySelector('[data-accordion-content]');
    accordion.removeAttribute('data-accordion-expanded');
    content.style.maxHeight = null;
}

function openAccordion(accordion) {
    const content = accordion.querySelector('[data-accordion-content]');
    accordion.setAttribute('data-accordion-expanded', "");
    content.style.maxHeight = content.scrollHeight + 'px';
}

export default {
    init: function () {
        document.querySelectorAll('[data-accordion]').forEach(container => {
            const group = container.closest('[data-accordion-group]');
            const accordions = group ? group.querySelectorAll('[data-accordion]') : null;
            const toggle = container.querySelector('[data-accordion-toggle]');

            toggle.addEventListener('click', (e) => {
                e.preventDefault();

                const opened = toggleAccordion(container);

                if (group) {
                    // 現在の要素のり前の要素が閉じられた場合は
                    // 閉じられたコンテンツの高さを取得
                    let isPrev = true;
                    let totalOffset = 0;

                    for (let i = 0; i < accordions.length; i++) {
                        if (accordions[i] === container) {
                            // 現要素以降の要素の高さを取得する必要なし
                            isPrev = false;
                            continue;
                        }

                        if (accordions[i].hasAttribute('data-accordion-expanded')) {
                            if (isPrev) {
                                // 閉じられた要素の高さを取得
                                let content = accordions[i].querySelector('[data-accordion-content]');
                                totalOffset += content.scrollHeight;
                            }

                            closeAccordion(accordions[i]);
                        }
                    }

                    if (opened) {
                        // 開かれた要素を画面内にスクロール
                        let target = container.getBoundingClientRect().top - totalOffset;
                        if (target < 20) {
                            const scrollContainer = group.closest('.modal') || window;
                            scrollContainer.scroll({
                                top: scrollContainer.scrollTop + target,
                                behavior: 'smooth',
                            });
                        }
                    }
                }
            });
        });
    }
};
